import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'SPARE_PART_ORDERS',
    itemActionName: 'SPARE_PART_ORDER',
});
